import { render, staticRenderFns } from "./StkP_Items.vue?vue&type=template&id=597658f8"
import script from "./StkP_Items.vue?vue&type=script&lang=js"
export * from "./StkP_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports